import { Pipe, PipeTransform } from "@angular/core";
import { random } from "lodash-es";

@Pipe({
  name: "randomArray",
  standalone: false
})
export class RandomArrayPipe implements PipeTransform {
  transform(value: any, min: number = 3, max: number = 4) {
    return new Array(random(min, max));
  }
}
